var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Buffer } from 'buffer';
import { convertPdfToImage } from 'src/shared/helpers/viewsHelpers';
var E_EXTENSION_FILES;
(function (E_EXTENSION_FILES) {
    E_EXTENSION_FILES["JPG"] = "jpg";
    E_EXTENSION_FILES["PNG"] = "png";
    E_EXTENSION_FILES["TIFF"] = "tiff";
    E_EXTENSION_FILES["TIF"] = "tif";
    E_EXTENSION_FILES["PDF"] = "pdf";
    E_EXTENSION_FILES["MP4"] = "mp4";
    E_EXTENSION_FILES["WEBM"] = "webm";
})(E_EXTENSION_FILES || (E_EXTENSION_FILES = {}));
export var E_BASE_64_BY_EXTENSION;
(function (E_BASE_64_BY_EXTENSION) {
    E_BASE_64_BY_EXTENSION["JPEG"] = "data:image/jpeg;base64,";
    E_BASE_64_BY_EXTENSION["PNG"] = "data:image/png;base64,";
    E_BASE_64_BY_EXTENSION["TIFF"] = "data:image/tiff;base64,";
    E_BASE_64_BY_EXTENSION["TIF"] = "data:image/tif;base64,";
    E_BASE_64_BY_EXTENSION["PDF"] = "data:application/pdf;base64,";
    E_BASE_64_BY_EXTENSION["MP4"] = "data:video/mp4;base64,";
    E_BASE_64_BY_EXTENSION["WEBM"] = "data:video/webm;base64,";
})(E_BASE_64_BY_EXTENSION || (E_BASE_64_BY_EXTENSION = {}));
export var getBase64ByExtension = function (fileExtension) {
    if (!fileExtension) {
        return E_BASE_64_BY_EXTENSION.JPEG;
    }
    switch (fileExtension.toLowerCase()) {
        case E_EXTENSION_FILES.MP4: {
            return E_BASE_64_BY_EXTENSION.MP4;
        }
        case E_EXTENSION_FILES.WEBM: {
            return E_BASE_64_BY_EXTENSION.WEBM;
        }
        case E_EXTENSION_FILES.PNG: {
            return E_BASE_64_BY_EXTENSION.PNG;
        }
        case E_EXTENSION_FILES.TIFF: {
            return E_BASE_64_BY_EXTENSION.TIFF;
        }
        case E_EXTENSION_FILES.TIF: {
            return E_BASE_64_BY_EXTENSION.TIF;
        }
        case E_EXTENSION_FILES.PDF: {
            return E_BASE_64_BY_EXTENSION.PDF;
        }
        case E_EXTENSION_FILES.JPG: {
            return E_BASE_64_BY_EXTENSION.JPEG;
        }
        default: {
            return E_BASE_64_BY_EXTENSION.JPEG;
        }
    }
};
export var filesParser = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var responseStatus, fileNamePrefix, contentDisposition, payloadToBuffer, bufferToBase64, fileName, indexStartExtension, fileExtension, pages, error_1, baseBase64, fileInBase64;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                responseStatus = (response === null || response === void 0 ? void 0 : response.status) || 520;
                if (responseStatus > 299) {
                    return [2 /*return*/, { status: responseStatus, error: true, errorMessage: 'Server error: check the network tab for more details' }];
                }
                fileNamePrefix = 'filename=';
                contentDisposition = response.headers['content-disposition'];
                payloadToBuffer = Buffer.from(response.payload, 'binary');
                bufferToBase64 = payloadToBuffer.toString('base64');
                fileName = contentDisposition === null || contentDisposition === void 0 ? void 0 : contentDisposition.substring(contentDisposition.indexOf(fileNamePrefix) + fileNamePrefix.length).replace(/"/g, '') // replace with global regex is same than replaceAll (better for navigator compatibility)
                ;
                indexStartExtension = fileName === null || fileName === void 0 ? void 0 : fileName.lastIndexOf('.');
                fileExtension = fileName === null || fileName === void 0 ? void 0 : fileName.substring(indexStartExtension + 1);
                if (!((fileExtension === null || fileExtension === void 0 ? void 0 : fileExtension.toLowerCase()) === E_EXTENSION_FILES.PDF.toLowerCase())) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, convertPdfToImage(payloadToBuffer)];
            case 2:
                pages = _a.sent();
                return [2 /*return*/, __assign(__assign({}, response), { payload: pages })];
            case 3:
                error_1 = _a.sent();
                console.warn(error_1, fileName);
                return [2 /*return*/, __assign(__assign({}, response), { payload: [] })];
            case 4:
                baseBase64 = getBase64ByExtension(fileExtension);
                fileInBase64 = "".concat(baseBase64).concat(bufferToBase64);
                return [2 /*return*/, __assign(__assign({}, response), { payload: [fileInBase64] })];
        }
    });
}); };
export var base64ToImg = function (imageBase64) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve(img); };
        img.onerror = function (err) { return resolve(null); };
        img.src = imageBase64;
    });
};
export var mergeFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
    var canvas, canvasContext, images, maxWidth, maxHeight;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                canvas = document.createElement('canvas');
                canvasContext = canvas.getContext('2d');
                return [4 /*yield*/, Promise.all(files.map(function (file) { return base64ToImg(file); }))];
            case 1:
                images = _a.sent();
                if (!images) {
                    console.error("An error occurred couldn't load images");
                    return [2 /*return*/, ''];
                }
                maxWidth = Math.max.apply(Math, images.map(function (img) { return img === null || img === void 0 ? void 0 : img.width; }));
                canvas.width = maxWidth * 2;
                maxHeight = Math.max.apply(Math, images.map(function (img) { return img === null || img === void 0 ? void 0 : img.height; }));
                canvas.height = maxHeight;
                return [4 /*yield*/, images.forEach(function (image, imageIndex) {
                        var _a = image || {}, width = _a.width, height = _a.height;
                        // If no image don't try to draw
                        if (!width && !height) {
                            return;
                        }
                        // Image need to take half of screen, so if isn't the widest image we resize to fit with widest
                        if (width < maxWidth) {
                            image.width = maxWidth;
                            image.height = (maxWidth * height) / width;
                        }
                        // As we set image side by side on x we want to enter Y
                        var coordToDrawY = image.height < maxHeight ? (maxHeight - image.height) / 2 : 0;
                        var coordToDrawX = maxWidth * imageIndex;
                        canvasContext.drawImage(image, coordToDrawX, coordToDrawY, image.width, image.height);
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/, canvas.toDataURL('image/jpeg')];
        }
    });
}); };
